import { Component, Input, OnInit, Inject } from '@angular/core';
import { IAppConfig } from '../../store';
import { APP_CONFIG } from '../../api/config';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { SiteURLUtils } from '../../common/site.url.utils';

@Component({
  selector: 'write-review-hotel-info',
  templateUrl: './write-review-hotel-info.component.html',
  styleUrls: ['./write-review-hotel-info.component.scss']
})
export class WriteReviewHotelInfoComponent implements OnInit {
  public hotelDetailUrl = '';
  private _hotel: Hotel;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) {
  }

  ngOnInit() {
  }

  @Input()
  set hotel(hotel: Hotel) {
    if (hotel) {
      this._hotel = hotel;
      this.hotelDetailUrl = SiteURLUtils.getLocalizedHotelReviewsUrl(this.appConfig, this._hotel.mnemonic, this._hotel.seoCity)
    }
  }

  get hotel() {
    return this._hotel;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/write-review-hotel-info/write-review-hotel-info.component.ts